import { TOGGLE_GDPR_NOTICE } from './gdprNotice.actions';

export const initialState = {
  isGdprNoticeVisible: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_GDPR_NOTICE: {
      return { ...state, isGdprNoticeVisible: !state.isGdprNoticeVisible };
    }

    default:
      return state;
  }
};
